/* Homepage redesign: "+" add-to-cart, Fan favorites tabs and arrows, header cart count. One delegated listener, so it survives Theme Editor reloads. */
(() => {
  if (window.__nhInit) return;
  window.__nhInit = true;

  // "+" buttons that add straight to the Shopify cart (merch, LGXNDS), through the theme's
  // own cart so its drawer opens and the header count updates.
  async function addToCart(button) {
    const id = Number(button.getAttribute('data-nh-add'));
    const quantity = Math.max(1, Number(button.getAttribute('data-nh-qty-val')) || 1);
    const plan = Number(button.getAttribute('data-nh-plan')) || 0;
    const item = plan ? { id, quantity, selling_plan: plan } : { id, quantity };
    const root = window.Shopify?.routes?.root || '/';
    // one request at a time; text buttons say "Adding…" until the drawer opens
    if (button.getAttribute('aria-busy') === 'true') return;
    const label = button.matches('.nh-btn') && !button.querySelector('svg') ? button.textContent : null;
    if (label) button.textContent = 'Adding…';
    button.setAttribute('aria-busy', 'true');
    try {
      const Cart = customElements.get('cart-element');
      if (Cart && Cart.addItems) {
        await Cart.addItems({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item], sections: Cart.sections || [] }),
        }, button);
      } else {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (!res.ok) throw new Error(res.statusText);
      }
      button.setAttribute('data-added', '');
      setTimeout(() => button.removeAttribute('data-added'), 1500);
    } catch (error) {
      console.error('Nourbar add to cart:', error);
      window.location.href = button.getAttribute('data-nh-url') || `${root}cart`;
    } finally {
      button.removeAttribute('aria-busy');
      if (label && button.textContent === 'Adding…') button.textContent = label;
      syncCount();
    }
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-nh-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }

    // Cart drawer: - / + / remove go through the theme's own <cart-element>, which posts the
    // change and swaps in the re-rendered items and subtotal.
    const step = event.target.closest('[data-nh-cd-qty], [data-nh-cd-remove]');
    if (step) {
      const item = step.closest('.cart--item');
      const cartEl = step.closest('cart-element');
      if (!item || !cartEl || typeof cartEl.tryToUpdateQuantity !== 'function') return;
      const now = Number(item.getAttribute('data-nh-qty')) || 1;
      const next = step.hasAttribute('data-nh-cd-remove') ? 0 : now + Number(step.getAttribute('data-nh-cd-qty'));
      if (next < 0) return;
      item.setAttribute('aria-busy', 'true');
      cartEl.tryToUpdateQuantity(item.getAttribute('data-line-num'), next)
        .finally(() => item.isConnected && item.removeAttribute('aria-busy'));
      return;
    }

    // Fan favorites tabs
    const tab = event.target.closest('[data-nh-tab]');
    if (tab) {
      const root = tab.closest('[data-nh-ff]');
      const key = tab.getAttribute('data-nh-tab');
      root.querySelectorAll('[data-nh-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      root.querySelectorAll('.nh-ff__track > .nh-card').forEach((card) => {
        card.hidden = key !== 'all' && card.getAttribute('data-nh-cat') !== key;
      });
      const track = root.querySelector('.nh-ff__track');
      track.scrollTo({ left: 0 });
      updateArrows(root);
      return;
    }

    // Fan favorites arrows
    const arrow = event.target.closest('[data-nh-dir]');
    if (arrow) {
      const root = arrow.closest('[data-nh-ff]');
      const track = root.querySelector('.nh-ff__track');
      const card = track.querySelector('.nh-card:not([hidden])');
      const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: Number(arrow.getAttribute('data-nh-dir')) * step });
      return;
    }

    // Close an open "Choose an app" popover when clicking elsewhere
    document.querySelectorAll('.nh-pop[open]').forEach((pop) => {
      if (!pop.contains(event.target)) pop.removeAttribute('open');
    });
  });

  // Cart drawer subscribe box: the switch (one-time <-> first frequency) and the frequency pills
  // post the line's new selling plan through the same cart/change call the theme uses, then let
  // the theme redraw the drawer.
  async function setLinePlan(control, plan) {
    const item = control.closest('.cart--item');
    if (!item || item.getAttribute('aria-busy') === 'true') return;
    const Cart = customElements.get('cart-element');
    const root = window.Shopify?.routes?.root || '/';
    item.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${window.Shopify?.routes?.cart_change || `${root}cart/change`}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(item.getAttribute('data-line-num')),
          quantity: Number(item.getAttribute('data-nh-qty')) || 1,
          selling_plan: plan ? Number(plan) : null,
          sections: Cart?.sections || [],
        }),
      });
      if (!res.ok) throw new Error(res.statusText);
      const { items, item_count: count, sections } = await res.json();
      if (!Cart?.updateAllHtml) throw new Error('no theme cart');
      Cart.fillBasket(items);
      Cart.updateTotals(count);
      Cart.updateAllHtml(sections);
    } catch (error) {
      console.error('Nourbar cart plan change:', error);
      window.location.reload();
    } finally {
      if (item.isConnected) item.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[data-nh-cd-subtoggle]');
    if (toggle) setLinePlan(toggle, toggle.checked ? toggle.value : null);
  });

  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-nh-cd-freq]');
    if (pill && pill.getAttribute('aria-checked') !== 'true') setLinePlan(pill, pill.getAttribute('data-nh-cd-freq'));
  });

  function updateArrows(root) {
    const track = root.querySelector('.nh-ff__track');
    const prev = root.querySelector('[data-nh-dir="-1"]');
    const next = root.querySelector('[data-nh-dir="1"]');
    if (!track || !prev || !next) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  function initFanFavorites() {
    document.querySelectorAll('[data-nh-ff]').forEach((root) => {
      const track = root.querySelector('.nh-ff__track');
      if (!track || track.__nh) return;
      track.__nh = true;
      track.addEventListener('scroll', () => updateArrows(root), { passive: true });
      updateArrows(root);
    });
  }

  // Header cart count: the theme sets data-cart-count on the badge; mirror it into the text.
  function setCount(pill, n) {
    if (pill.textContent !== String(n)) pill.textContent = n;
    if (pill.getAttribute('data-cart-count') !== String(n)) pill.setAttribute('data-cart-count', n);
  }

  function initCount() {
    document.querySelectorAll('.nh-hdr__count[data-cart-count]').forEach((pill) => {
      if (pill.__nh) return;
      pill.__nh = true;
      new MutationObserver(() => setCount(pill, pill.getAttribute('data-cart-count')))
        .observe(pill, { attributes: true, attributeFilter: ['data-cart-count'] });
    });
  }

  // Cart drawer note: opening it scrolls the box into view above the summary and focuses it.
  document.addEventListener('toggle', (event) => {
    const note = event.target;
    if (!note.classList || !note.classList.contains('nh-cd__note') || !note.open) return;
    const box = note.querySelector('textarea');
    if (!box) return;
    box.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    box.focus({ preventScroll: true });
  }, true);

  // Cart drawer, last item removed: the theme skips swapping in an item list with no items
  // (its image-keeping step returns false), so the removed line stayed on screen. Swap the
  // empty-cart body in ourselves from the same re-rendered section.
  window.addEventListener('theme:cart:drawer:updateHtml', (event) => {
    const html = event.detail && event.detail.section;
    if (typeof html !== 'string') return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.nh-cd__body');
    if (!fresh || fresh.getAttribute('data-nh-cd-count') !== '0') return;
    document.querySelectorAll('.nh-cd').forEach((cd) => {
      const body = cd.querySelector('.nh-cd__body');
      if (body && body.getAttribute('data-nh-cd-count') !== '0') body.replaceWith(fresh.cloneNode(true));
      const title = cd.querySelector('[data-nh-cd-title]');
      if (title) title.textContent = '0';
    });
  });

  // Cart drawer on phones: drag the handle / header down to close the sheet.
  (() => {
    let startY = null;
    let dy = 0;
    let side = null;
    const phone = window.matchMedia('(max-width: 767px)');
    document.addEventListener('touchstart', (event) => {
      const head = event.target.closest('.nh-cd__head');
      if (!head || !phone.matches || event.target.closest('button')) return;
      side = head.closest('.drawer--side');
      startY = event.touches[0].clientY;
      dy = 0;
    }, { passive: true });
    document.addEventListener('touchmove', (event) => {
      if (startY === null || !side) return;
      dy = Math.max(0, event.touches[0].clientY - startY);
      side.style.transition = 'none';
      side.style.transform = `translate3d(0, ${dy}px, 0)`;
    }, { passive: true });
    document.addEventListener('touchend', () => {
      if (startY === null || !side) return;
      side.style.transition = '';
      side.style.transform = '';
      if (dy > 90) document.querySelector('drawer-element')?.close();
      startY = null;
      side = null;
    });
  })();

  // Cart drawer title "Your cart (n)": the theme only swaps the items, so copy the new count.
  window.addEventListener('theme:cart:updated', () => {
    document.querySelectorAll('.nh-cd').forEach((cd) => {
      const body = cd.querySelector('[data-nh-cd-count]');
      const title = cd.querySelector('[data-nh-cd-title]');
      if (body && title) title.textContent = body.getAttribute('data-nh-cd-count');
    });
  });

  async function syncCount() {
    try {
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      document.querySelectorAll('.nh-hdr__count').forEach((pill) => setCount(pill, cart.item_count));
    } catch (e) {}
  }


  // Live Google reviews from the Reputon Google Reviews app. Reads the same public storefront
  // feed its own widget uses, then redraws the cards in the Figma design. The server-rendered
  // review blocks stay on screen if the feed cannot be reached.
  const REPUTON = 'https://grw.reputon.com/app/storefront/widget';
  let reputonFeed;

  function el(tag, cls, text) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function icon(tpl, name) {
    const i = tpl && tpl.content.querySelector(`[data-i="${name}"] svg`);
    return i ? i.cloneNode(true) : document.createTextNode('');
  }

  function reviewCard(r, tpl) {
    const card = el('article', 'nh-rv');
    const head = el('div', 'nh-rv__head');
    if (r.profilePhotoUrl) {
      const img = el('img', 'nh-rv__avatar');
      img.src = r.profilePhotoUrl; img.alt = ''; img.width = 36; img.height = 36; img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      head.append(img);
    } else {
      head.append(el('span', 'nh-rv__ai', (r.authorName || '?').trim().charAt(0).toUpperCase()));
    }
    const who = el('div', 'nh-rv__who');
    who.append(el('p', 'nh-title', r.authorName || 'Google user'), el('p', 'nh-tiny', r.relativeTimeDescription || ''));
    head.append(who, icon(tpl, 'google'));

    const rating = el('div', 'nh-rv__rating');
    const stars = el('span', 'nh-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${r.rating} out of 5`);
    for (let i = 1; i <= 5; i++) {
      const s = icon(tpl, 'star');
      if (i > r.rating) { const off = el('span', 'is-off'); off.append(s); stars.append(off); } else stars.append(s);
    }
    rating.append(stars, icon(tpl, 'verified'));

    const body = el('div', 'nh-rv__body');
    body.append(el('p', 'nh-rv__text nh-small', r.text || ''));
    const images = r.images || [];
    if (images.length) {
      const ph = el('span', 'nh-rv__photo');
      const img = el('img');
      img.src = images[0].thumbnailUrl || images[0].url; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      ph.append(img);
      if (images.length > 1) ph.append(el('span', null, `+${images.length - 1}`));
      body.append(ph);
    }
    card.append(head, rating, body);
    return card;
  }

  function summaryCard(items, count, title, tpl) {
    const card = el('article', 'nh-rv');
    const head = el('div', 'nh-rv__head');
    const ai = el('span', 'nh-rv__ai', 'AI'); ai.setAttribute('aria-hidden', 'true');
    const who = el('div', 'nh-rv__who');
    const based = el('p', 'nh-tiny', `Based on ${count} reviews`);
    who.append(el('p', 'nh-title', title), based);
    head.append(ai, who);
    const ul = el('ul', 'nh-rv__bullets nh-small');
    items.forEach((t) => { const li = el('li'); li.append(icon(tpl, 'check'), el('span', null, t)); ul.append(li); });
    card.append(head, ul);
    return card;
  }

  // LGXNDS product page: the product's own Judge.me reviews, read from Judge.me's public widget
  // feed (30 a page, the same feed its widget uses). Six cards first; "Load more" adds three and
  // fetches the next page when the loaded ones run out.
  const JDGM = 'https://judge.me/reviews/reviews_for_widget';

  function jdgmReviews(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return [...doc.querySelectorAll('.jdgm-rev')].map((r) => ({
      rating: Number(r.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')) || 0,
      title: (r.querySelector('.jdgm-rev__title')?.textContent || '').trim(),
      text: (r.querySelector('.jdgm-rev__body')?.textContent || '').trim(),
      name: (r.querySelector('.jdgm-rev__author')?.textContent || '').trim(),
      verified: r.getAttribute('data-verified-buyer') === 'true',
    }));
  }

  function jdgmCard(r, tpl, label) {
    const card = el('article', 'nh-lgx-rv');
    const stars = el('span', 'nh-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${r.rating} out of 5`);
    for (let i = 1; i <= 5; i++) {
      const st = icon(tpl, 'star');
      if (i > r.rating) { const off = el('span', 'is-off'); off.append(st); stars.append(off); } else stars.append(st);
    }
    card.append(stars);
    if (r.title) card.append(el('p', 'nh-lgx-rv__title', r.title));
    if (r.text) card.append(el('p', 'nh-lgx-rv__text', r.text));
    const who = el('p', 'nh-lgx-rv__who');
    who.append(el('span', 'nh-small', r.name || 'Customer'));
    if (r.verified && label) who.append(icon(tpl, 'verified'), el('span', 'nh-tiny', label));
    card.append(who);
    return card;
  }

  async function initJudgeme(grid) {
    if (grid.__nh) return;
    grid.__nh = true;
    const tpl = grid.parentElement.querySelector('template[data-nh-rv-icons]');
    const more = grid.parentElement.querySelector('.nh-lgx-reviews__more');
    const button = more?.querySelector('[data-nh-lgx-more]');
    const label = grid.getAttribute('data-nh-rv-label') || '';
    const params = new URLSearchParams({
      url: grid.getAttribute('data-shop'), shop_domain: grid.getAttribute('data-shop'),
      platform: 'shopify', product_id: grid.getAttribute('data-nh-jdgm'), per_page: '30',
    });
    let total = Number(grid.getAttribute('data-total')) || 0;
    let page = 0;
    let shown = 6;
    const cards = [];
    const fetchPage = async () => {
      params.set('page', String(page + 1));
      const res = await fetch(`${JDGM}?${params}`);
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();
      page += 1;
      if (data.total_count != null) total = Number(data.total_count);
      const reviews = jdgmReviews(data.html || '');
      reviews.forEach((r) => { const c = jdgmCard(r, tpl, label); grid.append(c); cards.push(c); });
      return reviews.length;
    };
    const show = () => {
      cards.forEach((c, i) => { c.hidden = i >= shown; });
      if (more) more.hidden = shown >= cards.length && cards.length >= total;
    };
    try {
      await fetchPage();
      show();
    } catch (e) {
      return; // the section keeps its heading; nothing else to show
    }
    button?.addEventListener('click', async () => {
      shown += 3;
      if (shown > cards.length && cards.length < total && button.getAttribute('aria-busy') !== 'true') {
        button.setAttribute('aria-busy', 'true');
        try {
          if (!(await fetchPage())) total = cards.length; // feed ran dry: stop offering more
        } catch (e) {
          total = cards.length;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
      show();
    });
  }

  async function initReviews() {
    const jdgm = document.querySelector('[data-nh-jdgm]');
    if (jdgm) initJudgeme(jdgm);
    const grid = document.querySelector('[data-nh-reviews]');
    const anyRating = document.querySelector('[data-nh-g]');
    if (!grid && !anyRating) return;
    const shop = grid?.getAttribute('data-nh-reviews') || window.Shopify?.shop;
    if (!shop) return;
    try {
      reputonFeed = reputonFeed || fetch(`${REPUTON}?shop=${encodeURIComponent(shop)}`).then((r) => (r.ok ? r.json() : null));
      const data = await reputonFeed;
      const biz = data && data.business && data.business[0];
      if (!biz) return;

      // rating, review count and "write a review" link everywhere on the page (hero + reviews)
      document.querySelectorAll('[data-nh-g="rating"]').forEach((e) => { if (biz.rating) e.textContent = biz.rating.toFixed(1); });
      document.querySelectorAll('[data-nh-g="count"]').forEach((e) => { if (biz.reviewsNumber) e.textContent = biz.reviewsNumber; });
      document.querySelectorAll('[data-nh-g="write"]').forEach((e) => { if (biz.writeReviewUrl) e.href = biz.writeReviewUrl; });

      if (!grid || grid.__nh) return;
      const min = Number(grid.getAttribute('data-min') || 4);
      const max = Number(grid.getAttribute('data-count') || 7);
      const reviews = (biz.reviews || []).filter((r) => !r.hide && r.rating >= min && (r.text || '').trim()).slice(0, max);
      if (!reviews.length) return;
      const tpl = grid.parentElement.querySelector('template[data-nh-rv-icons]');
      if (grid.getAttribute('data-nh-rv-style') === 'lgx') {
        // LGXNDS V2 cards: stars, text, name + source; six first, "Load more" adds three
        const label = grid.getAttribute('data-nh-rv-label') || '';
        const cards = reviews.map((r) => {
          const card = el('article', 'nh-lgx-rv');
          const stars = el('span', 'nh-stars');
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', `${r.rating} out of 5`);
          for (let i = 1; i <= 5; i++) {
            const st = icon(tpl, 'star');
            if (i > r.rating) { const off = el('span', 'is-off'); off.append(st); stars.append(off); } else stars.append(st);
          }
          const who = el('p', 'nh-lgx-rv__who');
          who.append(el('span', 'nh-small', r.authorName || 'Google user'), icon(tpl, 'verified'), el('span', 'nh-tiny', label));
          card.append(stars, el('p', 'nh-lgx-rv__text', r.text || ''), who);
          return card;
        });
        grid.__nh = true;
        grid.replaceChildren(...cards);
        grid.setAttribute('data-nh-live', '');
        const more = grid.parentElement.querySelector('.nh-lgx-reviews__more');
        let shown = 6;
        const show = () => {
          cards.forEach((c, i) => { c.hidden = i >= shown; });
          if (more) more.hidden = shown >= cards.length;
        };
        more?.querySelector('[data-nh-lgx-more]')?.addEventListener('click', () => { shown += 3; show(); });
        show();
        return;
      }
      const oldTitle = grid.querySelector('.nh-rv__ai + .nh-rv__who .nh-title');
      const items = (biz.summary && biz.summary.items) || [];
      const cards = [];
      if (items.length) cards.push(summaryCard(items, biz.reviewsNumber || reviews.length, oldTitle ? oldTitle.textContent : 'AI Summary', tpl));
      reviews.forEach((r) => cards.push(reviewCard(r, tpl)));
      grid.__nh = true;
      grid.replaceChildren(...cards);
      grid.setAttribute('data-nh-live', '');
    } catch (e) {
      // keep the typed-in reviews
    }
  }

  // Collection page: All / Iced / Hot / Best sellers tabs, phone "Load more", 4 <-> 2 columns,
  // sort. A card can match several tabs (data-nh-cat="iced best"). The theme's filter drawer
  // swaps the grid by AJAX, so the state is re-applied on its reload event.
  const colRoot = () => document.querySelector('[data-nh-col]');
  const phone = window.matchMedia('(max-width: 767px)');

  function applyCollection(root = colRoot()) {
    if (!root) return;
    const key = root.getAttribute('data-tab') || 'all';
    const pages = Number(root.getAttribute('data-pages')) || 1;
    const step = phone.matches ? Number(root.getAttribute('data-limit')) : Number(root.getAttribute('data-step')) || Infinity;
    const limit = step * pages;
    const cards = [...root.querySelectorAll('[data-body-grid] > .nh-card')];
    let matched = 0;
    cards.forEach((card) => {
      const cats = (card.getAttribute('data-nh-cat') || '').split(' ');
      const match = key === 'all' || cats.includes(key);
      if (match) matched += 1;
      card.hidden = !match || matched > limit;
    });
    const shown = Math.min(matched, limit);
    // over 250 products: Shopify's next page is still to fetch, so "All" counts the whole collection
    const more = root.querySelector('[data-nh-more]');
    // search page: Sort / Refine swap the page numbers by AJAX, carrying the new next-page link
    const marker = root.querySelector('[data-nh-next]');
    if (marker && more) {
      const url = marker.getAttribute('data-nh-next');
      if (url) more.setAttribute('data-next', url);
      else more.removeAttribute('data-next');
      marker.remove();
    }
    const next = more?.getAttribute('data-next');
    const total = key === 'all' && next ? Math.max(Number(root.getAttribute('data-total')) || 0, matched) : matched;
    root.querySelectorAll('[data-nh-count]').forEach((el) => { el.textContent = total; });
    // "Load more" replaces Shopify's page numbers (kept in the markup for no-JS)
    const pager = root.querySelector('[data-body-pagination]');
    if (pager) pager.hidden = true;
    if (more) {
      more.hidden = shown >= matched && !next;
    }
    document.querySelectorAll('[data-nh-ctab]').forEach((t) => t.setAttribute('aria-selected', String(t.getAttribute('data-nh-ctab') === key)));
  }

  // "Load more": reveal the next step of loaded cards; once those run out, fetch Shopify's next
  // page (250 more) and append its cards, so collections over 250 need no page numbers.
  async function loadMore(root, button) {
    if (!root || button.getAttribute('aria-busy') === 'true') return;
    const cards = () => root.querySelectorAll('[data-body-grid] > .nh-card:not([hidden])').length;
    const before = cards();
    root.setAttribute('data-pages', String((Number(root.getAttribute('data-pages')) || 1) + 1));
    applyCollection(root);
    const more = root.querySelector('[data-nh-more]');
    const next = more?.getAttribute('data-next');
    if (cards() > before || !next) return;
    button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(next, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(res.statusText);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = root.querySelector('[data-body-grid]');
      const seen = new Set([...grid.children].map((c) => c.getAttribute('data-product-id')).filter(Boolean));
      doc.querySelectorAll('[data-body-grid] > .nh-card').forEach((card) => {
        const id = card.getAttribute('data-product-id');
        if (id && seen.has(id)) return;
        grid.appendChild(document.importNode(card, true));
      });
      const nextMore = doc.querySelector('[data-nh-more]');
      const after = nextMore?.getAttribute('data-next');
      if (after) more.setAttribute('data-next', after);
      else more.removeAttribute('data-next');
    } catch (error) {
      console.error('Nourbar load more:', error);
      window.location.href = next;
      return;
    } finally {
      button.removeAttribute('aria-busy');
    }
    applyCollection(root);
  }

  function initCollection() {
    const root = colRoot();
    if (!root) return;
    const grid = root.querySelector('[data-body-grid]');
    const view = root.querySelector('[data-nh-view]');
    let cols = null;
    try { cols = localStorage.getItem('nh-col-view'); } catch (e) { /* storage blocked */ }
    if (cols === '2' && grid && view) {
      grid.setAttribute('data-view', '2');
      view.setAttribute('aria-pressed', 'true');
    }
    // the Iced / Hot / Best sellers tab rides in the URL, so sorting (a reload) keeps it
    const tab = new URL(window.location.href).searchParams.get('tab');
    if (tab && root.querySelector(`[data-nh-ctab="${CSS.escape(tab)}"]`)) root.setAttribute('data-tab', tab);
    applyCollection(root);
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-nh-ctab]');
    if (tab) {
      const root = colRoot();
      if (!root) return;
      const key = tab.getAttribute('data-nh-ctab');
      root.setAttribute('data-tab', key);
      root.removeAttribute('data-pages');
      applyCollection(root);
      const url = new URL(window.location.href);
      if (key === 'all') url.searchParams.delete('tab');
      else url.searchParams.set('tab', key);
      window.history.replaceState(window.history.state, '', url.toString());
      return;
    }

    const load = event.target.closest('[data-nh-load]');
    if (load) {
      loadMore(colRoot(), load);
      return;
    }

    const view = event.target.closest('[data-nh-view]');
    if (view) {
      const grid = colRoot().querySelector('[data-body-grid]');
      const two = view.getAttribute('aria-pressed') !== 'true';
      view.setAttribute('aria-pressed', String(two));
      view.setAttribute('aria-label', two ? 'Show smaller cards' : 'Show bigger cards');
      if (two) grid.setAttribute('data-view', '2');
      else grid.removeAttribute('data-view');
      try { localStorage.setItem('nh-col-view', two ? '2' : '4'); } catch (e) { /* storage blocked */ }
      return;
    }
  });

  // Phones: the tabs live in the theme's filter drawer, so copy them in the first time it opens.
  // Capture phase: the theme's drawer button stops the click from bubbling. The theme also
  // switches the drawer to its filter view after this click, so wait a moment.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nh-col__filter')) return;
    setTimeout(() => {
      const tabs = colRoot()?.querySelector('.nh-col__bar .nh-tabs');
      const form = document.querySelector('.filter--root .filter--form');
      if (tabs && form && !form.querySelector('.nh-col-drawer-tabs')) {
        const copy = tabs.cloneNode(true);
        copy.className = 'nh nh-col-drawer-tabs';
        form.prepend(copy);
      }
    }, 60);
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-nh-sort]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  window.addEventListener('theme:navigation:reloaded', () => applyCollection());
  phone.addEventListener('change', () => applyCollection());

  // Product page: gallery thumbnails and dots, Pickup / Delivery, cart variants and quantity,
  // today's opening hours, Share, and the phone sticky bar that appears once the main button
  // has scrolled out of view.
  function initProduct() {
    const root = document.querySelector('[data-nh-pdp]');
    if (!root || root.hasAttribute('data-nh-ready')) return;
    root.setAttribute('data-nh-ready', '');

    const slides = root.querySelector('[data-nh-slides]');
    const dots = [...root.querySelectorAll('.nh-pdp__dots span')];
    const thumbs = [...root.querySelectorAll('[data-nh-thumb]')];
    const mark = (i) => {
      dots.forEach((d, j) => d.classList.toggle('is-on', i === j));
      thumbs.forEach((t, j) => t.setAttribute('aria-selected', String(i === j)));
    };
    if (slides) {
      slides.addEventListener('scroll', () => mark(Math.round(slides.scrollLeft / slides.clientWidth)), { passive: true });
    }

    const hours = root.querySelector('[data-nh-hours]');
    if (hours) {
      const day = new Date().getDay();
      const text = day === 0 || day === 6 ? hours.getAttribute('data-weekend') : hours.getAttribute('data-weekday');
      if (text) hours.textContent = `Open today · ${text}`;
    }

    const buy = root.querySelector('[data-nh-variants]');
    if (buy) {
      let variants = [];
      try { variants = JSON.parse(buy.getAttribute('data-nh-variants')); } catch (e) { /* keep defaults */ }
      const add = buy.querySelector('[data-nh-pdp-add]');
      const pick = () => {
        const chosen = [...buy.querySelectorAll('[data-nh-opt]:checked')].map((i) => i.value);
        const v = variants.find((x) => x.options.every((o, k) => chosen[k] === undefined || chosen[k] === o));
        if (!v || !add) return;
        add.setAttribute('data-nh-add', v.id);
        add.disabled = !v.available;
        add.textContent = v.available ? 'Add to cart' : 'Sold out';
        const money = (c) => (window.Shopify?.formatMoney ? window.Shopify.formatMoney(c) : `$${(c / 100).toFixed(2)}`);
        const price = root.querySelector('[data-nh-price]');
        if (price) price.textContent = money(v.price);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      };
      buy.addEventListener('change', (e) => { if (e.target.matches('[data-nh-opt]')) pick(); });
      buy.addEventListener('click', (e) => {
        const step = e.target.closest('[data-nh-qty]');
        if (!step) return;
        const input = buy.querySelector('[data-nh-qty-input]');
        input.value = Math.max(1, (Number(input.value) || 1) + Number(step.getAttribute('data-nh-qty')));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      buy.addEventListener('input', (e) => {
        if (e.target.matches('[data-nh-qty-input]') && add) add.setAttribute('data-nh-qty-val', e.target.value);
      });
      root.querySelector('[data-nh-sticky-add]')?.addEventListener('click', () => add?.click());
    }

    const sticky = root.querySelector('[data-nh-pdp-sticky]');
    const cta = root.querySelector('.nh-pdp__cta');
    // a scroll check, not an IntersectionObserver: jumping straight from below the button to
    // above it never crosses the observer threshold, which left the bar stuck open
    if (sticky && cta) {
      let queued = false;
      const update = () => {
        queued = false;
        sticky.hidden = cta.getBoundingClientRect().bottom > 0;
      };
      window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  }

  document.addEventListener('click', async (event) => {
    const thumb = event.target.closest('[data-nh-thumb]');
    if (thumb) {
      const slides = thumb.closest('[data-nh-pdp], [data-nh-lgx]').querySelector('[data-nh-slides]');
      const i = Number(thumb.getAttribute('data-nh-thumb'));
      slides.scrollTo({ left: i * slides.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }

    const share = event.target.closest('[data-nh-share]');
    if (share) {
      const data = { title: share.getAttribute('data-title') || document.title, url: window.location.href.split('?')[0] };
      try {
        if (navigator.share) await navigator.share(data);
        else {
          await navigator.clipboard.writeText(data.url);
          share.setAttribute('data-copied', '');
          setTimeout(() => share.removeAttribute('data-copied'), 2000);
        }
      } catch (e) { /* cancelled */ }
    }
  });

  // LGXNDS product page V2: gallery, size / bundle / subscribe choice, quantity, Add to bag
  // (with the selling plan when subscribing), Shop Pay, tabs, the phone sticky bar and the
  // "Add to bag" buttons further down the page that press the main one.
  const lgxMoney = (c) => (window.Shopify?.formatMoney ? window.Shopify.formatMoney(c) : `$${(c / 100).toFixed(2)}`);
  // "Deliver every 4 weeks, 15% off" (the app's name) -> "Delivery every 4 weeks" (Figma); the discount is already in the title
  const lgxPlanName = (n) => String(n).split(', ')[0].replace(/^Deliver every/, 'Delivery every');

  function initLgx() {
    const root = document.querySelector('[data-nh-lgx]');
    if (!root || root.hasAttribute('data-nh-ready')) return;
    root.setAttribute('data-nh-ready', '');

    const slides = root.querySelector('[data-nh-slides]');
    const thumbs = [...root.querySelectorAll('[data-nh-thumb]')];
    if (slides) {
      slides.addEventListener('scroll', () => {
        const i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((t, j) => t.setAttribute('aria-selected', String(i === j)));
      }, { passive: true });
    }

    // a flavour / size with its own photo (the variant's image in admin) brings the gallery to it,
    // instantly (a smooth glide fights the scroll snap and can stop a slide short)
    const showMedia = (i) => {
      if (!slides || !(i >= 0)) return;
      slides.scrollTo({ left: i * slides.clientWidth, behavior: 'auto' });
      const t = thumbs[i];
      const box = t?.parentElement;
      if (t && box) {
        const tr = t.getBoundingClientRect();
        const br = box.getBoundingClientRect();
        box.scrollTo({
          top: box.scrollTop + (tr.top - br.top) - (box.clientHeight - tr.height) / 2,
          left: box.scrollLeft + (tr.left - br.left) - (box.clientWidth - tr.width) / 2,
          behavior: 'auto',
        });
      }
    };

    const buy = root.querySelector('[data-nh-lgx-buy]');
    if (!buy) return;
    const add = buy.querySelector('[data-nh-lgx-add]');
    const qtyInput = buy.querySelector('[data-nh-qty-input]');
    const planSelect = buy.querySelector('[data-nh-lgx-plan]');
    const subOpt = buy.querySelector('.nh-lgx__opt--sub');
    const label = buy.getAttribute('data-add-label') || 'Add to bag';
    const subTitle = buy.getAttribute('data-sub-title') || '';
    let variants = [];
    try { variants = JSON.parse(buy.getAttribute('data-nh-variants')); } catch (e) { /* keep server state */ }
    const cardData = (input) => { try { return JSON.parse(input.getAttribute('data-nh-lgx-card')); } catch (e) { return null; } };

    const current = () => {
      const input = buy.querySelector('[data-nh-lgx-card]:checked') || buy.querySelector('[data-nh-lgx-card]');
      return input ? { input, data: cardData(input) } : null;
    };

    function render(keepPlan) {
      const c = current();
      if (!c || !c.data) return;
      const d = c.data;
      const plans = d.plans || [];
      const qty = Math.max(1, Number(qtyInput?.value) || 1);

      // subscribe option only when this product has selling plans
      if (subOpt) {
        subOpt.hidden = plans.length === 0;
        if (planSelect && !keepPlan) {
          planSelect.innerHTML = plans.map((p) => `<option value="${p.id}">${lgxPlanName(p.name).replace(/</g, '&lt;')}</option>`).join('');
        }
        if (plans.length === 0) {
          // e.g. a bundle card (one-time only): fall back to one-time, and remember that we did
          const once = buy.querySelector('input[name="nh-lgx-buy"][value="once"]');
          if (once && !once.checked) {
            once.checked = true;
            buy.__nhAutoOnce = true;
          }
        } else if (buy.__nhAutoOnce) {
          // back on a product with plans: restore the default subscribe choice
          const sub = buy.querySelector('input[name="nh-lgx-buy"][value="sub"]');
          if (sub) sub.checked = true;
          buy.__nhAutoOnce = false;
        }
      }
      const subscribing = !!buy.querySelector('input[name="nh-lgx-buy"][value="sub"]:checked') && plans.length > 0;
      const plan = plans.find((p) => String(p.id) === planSelect?.value) || plans[0];

      const pct = plan && d.price > 0 ? `${Math.round(((d.price - plan.price) * 100) / d.price)}%` : '';
      const titleEl = buy.querySelector('[data-nh-lgx-subtitle]');
      if (titleEl) titleEl.textContent = subTitle.replace('[percent]', pct).trim();
      const subPrice = buy.querySelector('[data-nh-lgx-subprice]');
      if (subPrice && plan) subPrice.textContent = lgxMoney(plan.price);
      buy.querySelectorAll('[data-nh-lgx-onceprice], [data-nh-lgx-onceprice2]').forEach((el) => { el.textContent = lgxMoney(d.price); });

      const unit = subscribing ? plan.price : d.price;
      if (add) {
        add.setAttribute('data-nh-add', d.id);
        // a 2- or 3-pack card adds that many of the product per quantity step
        add.setAttribute('data-nh-qty-val', qty * (d.units || 1));
        if (subscribing) add.setAttribute('data-nh-plan', plan.id);
        else add.removeAttribute('data-nh-plan');
        add.disabled = !d.available;
        add.textContent = d.available ? `${label} — ${lgxMoney(unit * qty)}` : 'Sold out';
      }
      document.querySelectorAll('[data-nh-lgx-price-label]').forEach((btn) => {
        const span = btn.querySelector('[data-nh-lgx-label]');
        if (span) span.textContent = `${btn.getAttribute('data-nh-lgx-price-label')} — ${lgxMoney(unit * qty)}`;
      });
      const st = root.querySelector('[data-nh-lgx-sticky-title]');
      if (st) st.textContent = `${d.title.split(' — ')[0].split(' - ')[0]} · ${d.label.toLowerCase()}`;
      const ss = root.querySelector('[data-nh-lgx-sticky-sub]');
      if (ss) ss.textContent = `${lgxMoney(unit)}${subscribing ? ' · Subscribe & save' : ''}`;
    }

    buy.addEventListener('change', (e) => {
      if (e.target.matches('[data-nh-opt]')) {
        // size / flavour pills change the variant of this product (the first card)
        const chosen = [...buy.querySelectorAll('[data-nh-opt]:checked')].map((i) => i.value);
        const v = variants.find((x) => x.options.every((o, k) => chosen[k] === undefined || chosen[k] === o));
        const own = buy.querySelector('[data-nh-lgx-card]');
        const d = own && cardData(own);
        if (v && d) {
          Object.assign(d, { id: v.id, price: v.price, available: v.available, plans: v.plans });
          own.setAttribute('data-nh-lgx-card', JSON.stringify(d));
          // 2- and 3-pack cards of this product follow the flavour: same variant, photo, pack price and saving
          buy.querySelectorAll('[data-nh-lgx-card]').forEach((input) => {
            const pd = cardData(input);
            if (!pd || !(input === own || pd.units > 1)) return;
            const cardImg = input.closest('.nh-lgx__card')?.querySelector('.nh-lgx__card-img img');
            if (cardImg && v.thumb) { cardImg.removeAttribute('srcset'); cardImg.src = v.thumb; }
            if (input === own) return;
            const line = v.price * pd.units;
            const off = Math.round((line * (pd.pct || 0)) / 100);
            Object.assign(pd, { id: v.id, price: line - off, available: v.available, plans: [] });
            input.setAttribute('data-nh-lgx-card', JSON.stringify(pd));
            const card = input.closest('.nh-lgx__card');
            const priceEl = card?.querySelector('[data-nh-lgx-card-price]');
            if (priceEl) priceEl.textContent = lgxMoney(line - off);
            const saveEl = card?.querySelector('[data-nh-lgx-card-save]');
            if (saveEl) { saveEl.textContent = `Save ${lgxMoney(off)}`; saveEl.hidden = !(off > 0); }
          });
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
          if (v.media >= 0) showMedia(v.media);
          const stickyImg = root.querySelector('[data-nh-lgx-sticky-img] img');
          if (stickyImg && v.thumb) { stickyImg.removeAttribute('srcset'); stickyImg.src = v.thumb; }
        }
        render(false);
      } else if (e.target.matches('[data-nh-lgx-card]')) render(false);
      else if (e.target.matches('[data-nh-lgx-plan]') || e.target.name === 'nh-lgx-buy') render(true);
    });
    buy.addEventListener('click', (e) => {
      const step = e.target.closest('[data-nh-qty]');
      if (!step || !qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + Number(step.getAttribute('data-nh-qty')));
      render(true);
    });
    qtyInput?.addEventListener('input', () => render(true));

    // Shop Pay: put the choice in the cart, then straight to checkout with Shop Pay selected
    buy.querySelector('[data-nh-lgx-shoppay]')?.addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      if (!add || add.disabled || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      const root_ = window.Shopify?.routes?.root || '/';
      const item = { id: Number(add.getAttribute('data-nh-add')), quantity: Number(add.getAttribute('data-nh-qty-val')) || 1 };
      if (add.getAttribute('data-nh-plan')) item.selling_plan = Number(add.getAttribute('data-nh-plan'));
      try {
        const res = await fetch(`${root_}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
        if (!res.ok) throw new Error(res.statusText);
        window.location.href = `${root_}checkout?payment=shop_pay`;
      } catch (err) {
        btn.removeAttribute('aria-busy');
        add.click();
      }
    });

    // tabs (arrow keys move between them)
    const tabs = root.querySelector('[data-nh-lgx-tabs]');
    if (tabs) {
      const list = [...tabs.querySelectorAll('[role="tab"]')];
      const select = (tab) => {
        list.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
      tabs.addEventListener('keydown', (e) => {
        const i = list.indexOf(document.activeElement);
        if (i < 0 || !['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        const next = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
        select(next);
        next.focus();
      });
    }

    // phone sticky bar once the main Add button has scrolled away
    const sticky = root.querySelector('[data-nh-lgx-sticky]');
    if (sticky && add) {
      let queued = false;
      const update = () => { queued = false; sticky.hidden = add.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }

    // opened on a flavour (?variant=) that has its own photo: start the gallery there
    const chosen0 = [...buy.querySelectorAll('[data-nh-opt]:checked')].map((i) => i.value);
    const v0 = chosen0.length && variants.find((x) => x.options.every((o, k) => chosen0[k] === undefined || chosen0[k] === o));
    if (v0 && v0.media > 0) requestAnimationFrame(() => showMedia(v0.media));

    render(false);
  }

  document.addEventListener('click', (event) => {
    const proxy = event.target.closest('[data-nh-lgx-proxy]');
    if (proxy) {
      document.querySelector('[data-nh-lgx-add]')?.click();
      return;
    }
    // reel viewer: a click on the play button or anywhere on a reel card's media
    const reelCard = event.target.closest('.nh-lgx-video__media');
    const reel = event.target.closest('[data-nh-lgx-reel]') || reelCard?.querySelector('[data-nh-lgx-reel]');
    if (reel) {
      const all = [...(reel.closest('section') || document).querySelectorAll('[data-nh-lgx-reel]')];
      openReel(all, all.indexOf(reel), reel);
      return;
    }
    const play = event.target.closest('[data-nh-lgx-play]');
    if (play) {
      const tpl = play.parentElement.querySelector('template');
      if (!tpl) return;
      play.parentElement.querySelectorAll(':scope > img, :scope > video').forEach((el) => el.remove());
      play.replaceWith(tpl.content.cloneNode(true));
      return;
    }
    const write = event.target.closest('[data-nh-lgx-write]');
    if (write) {
      const app = write.closest('.nh-lgx-reviews')?.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, [class*="write-rev"]');
      if (app) app.click();
      else write.closest('.nh-lgx-reviews')?.querySelector('.nh-lgx-reviews__app')?.scrollIntoView({ behavior: 'smooth' });
    }
  });

  // Reel viewer for the LGXNDS videos: a dark overlay with a 9:16 player (like an Instagram reel),
  // next / previous (buttons, arrow keys, swipe up/down on phones), looping, with sound.
  // Built once and reused; Esc, the close button or the backdrop closes it and returns focus.
  let reelState = null;
  function reelEl() {
    let el = document.querySelector('[data-nh-reel]');
    if (el) return el;
    const arrow = (d) => `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${d}"/></svg>`;
    el = document.createElement('div');
    el.className = 'nh nh-reel';
    el.setAttribute('data-nh-reel', '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Video');
    el.hidden = true;
    el.innerHTML = `
      <div class="nh-reel__backdrop" data-nh-reel-close></div>
      <div class="nh-reel__stage">
        <video class="nh-reel__video" playsinline controls loop preload="auto"></video>
        <p class="nh-reel__title" aria-live="polite"></p>
      </div>
      <button type="button" class="nh-reel__btn nh-reel__close" data-nh-reel-close aria-label="Close video">${arrow('M6 6l12 12M18 6L6 18')}</button>
      <div class="nh-reel__nav">
        <button type="button" class="nh-reel__btn" data-nh-reel-step="-1" aria-label="Previous video">${arrow('M6 15l6-6 6 6')}</button>
        <span class="nh-reel__count"></span>
        <button type="button" class="nh-reel__btn" data-nh-reel-step="1" aria-label="Next video">${arrow('M6 9l6 6 6-6')}</button>
      </div>`;
    document.body.appendChild(el);
    const video = el.querySelector('video');
    video.addEventListener('loadedmetadata', () => {
      // a landscape clip is shown whole; reels fill the frame
      el.classList.toggle('is-wide', video.videoWidth > video.videoHeight);
    });
    el.addEventListener('click', (e) => {
      if (e.target.closest('[data-nh-reel-close]')) closeReel();
      const step = e.target.closest('[data-nh-reel-step]');
      if (step) showReel(reelState.i + Number(step.getAttribute('data-nh-reel-step')));
    });
    let y0 = null;
    el.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      if (y0 === null) return;
      const dy = e.changedTouches[0].clientY - y0;
      y0 = null;
      if (Math.abs(dy) > 60) showReel(reelState.i + (dy < 0 ? 1 : -1));
    });
    document.addEventListener('keydown', (e) => {
      if (el.hidden) return;
      if (e.key === 'Escape') closeReel();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); showReel(reelState.i + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); showReel(reelState.i - 1); }
    });
    return el;
  }
  function showReel(i) {
    const { items } = reelState;
    const n = items.length;
    reelState.i = ((i % n) + n) % n;
    const item = items[reelState.i];
    const el = reelEl();
    const video = el.querySelector('video');
    video.src = item.getAttribute('data-nh-lgx-reel');
    el.querySelector('.nh-reel__title').textContent = item.getAttribute('data-nh-lgx-reel-title') || '';
    el.querySelector('.nh-reel__count').textContent = `${reelState.i + 1} / ${n}`;
    el.querySelector('.nh-reel__nav').hidden = n < 2;
    video.play().catch(() => {});
  }
  function openReel(items, i, opener) {
    const el = reelEl();
    reelState = { items, i: 0, opener };
    el.hidden = false;
    document.documentElement.classList.add('nh-reel-open');
    showReel(i < 0 ? 0 : i);
    el.querySelector('.nh-reel__close').focus({ preventScroll: true });
  }
  function closeReel() {
    const el = document.querySelector('[data-nh-reel]');
    if (!el || el.hidden) return;
    const video = el.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    el.hidden = true;
    document.documentElement.classList.remove('nh-reel-open');
    reelState?.opener?.focus({ preventScroll: true });
  }

  // Ingredients: every row open on desktop (a table), accordions on phones (first one open)
  function initLgxIngr() {
    const rows = [...document.querySelectorAll('[data-nh-lgx-ingr]')];
    if (!rows.length) return;
    const apply = () => rows.forEach((r, i) => { if (!phone.matches) r.open = true; else if (!r.__nhTouched) r.open = i === 0; });
    rows.forEach((r) => r.addEventListener('toggle', () => { if (phone.matches) r.__nhTouched = true; }));
    apply();
    phone.addEventListener('change', apply);
  }

  // Sticky site header height as --nh-hdr-h, so sticky galleries sit below it, not under it
  function initHeaderHeight() {
    const hdr = document.querySelector('.shopify-section-group-header-group[id*="nh_header"]') || document.querySelector('.nh-hdr');
    if (!hdr || hdr.__nhH) return;
    hdr.__nhH = true;
    const set = () => document.documentElement.style.setProperty('--nh-hdr-h', `${Math.round(hdr.getBoundingClientRect().height)}px`);
    new ResizeObserver(set).observe(hdr);
    set();
  }

  const init = () => {
    initHeaderHeight();
    initLgx();
    initLgxIngr();
    initFanFavorites();
    initCount();
    initReviews();
    initCollection();
    initProduct();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
